import { render } from "./_Etapa4.vue?vue&type=template&id=0dc756a3&scoped=true"
import script from "./_Etapa4.vue?vue&type=script&lang=ts"
export * from "./_Etapa4.vue?vue&type=script&lang=ts"

import "./_Etapa4.vue?vue&type=style&index=0&id=0dc756a3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0dc756a3"

export default script